import { Link } from "react-router-dom";
import Back from "../../assets/icons/back.svg";
import ReviewsCustomer from "../../components/common/reviewsCustomer";
import { Card, Input, Pagination, Spin } from "antd";
import ReviewsOrderDetails from "../../components/common/reviewsOrderDetails";
import { useEffect, useState } from "react";
import DeleteMemberModal from "../../components/common/modalMember";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchReviewList } from "../../store/slices/reviewSlice";
import Button from "../../components/common/button";
import { colors } from "../../share/constants/enums";
import TextArea from "../../components/common/textArea";
import { updateReview } from "../../api/reviews";
import { LoadingOutlined } from "@ant-design/icons";

const Reviews = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPagesize] = useState(3);
  const [render, setRender] = useState(false);
  const [showReplySection, setShowReplySection] = useState(false);
  const [openReplyIndex, setOpenReplyIndex] = useState(null);
  const [reviewText, setReviewText] = useState();
  const reviews = useSelector((state) => state?.review?.res);
  const reviewsLoader = useSelector((state) => state?.review?.isLoading);
  const toggleReplySection = (index) => {
    setOpenReplyIndex(openReplyIndex === index ? null : index);
    setShowReplySection(!showReplySection);
  };

  const hideModal = () => {
    setIsOpen(false);
  };
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.user?.response);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };
  useEffect(() => {
    const payload = {
      businessId: localStorage.getItem("businessId"),
      currentPage: currentPage,
      itemPerPage: pageSize,
    };
    dispatch(fetchReviewList(payload));
  }, [currentPage, pageSize, render]);
  if (!reviews?.totalItems) {
    return (
      <div className="text-xl opacity-50 flex justify-center items-center relative top-25">
        No Reviews Yet...
      </div>
    );
  }
  const onReplyButtonClick = async () => {
    const payload = {
      comments: [
        {
          commentUser: user?._id,
          commentText: reviewText,
        },
      ],
    };
    const res = await updateReview(openReplyIndex, payload);
    if (res) {
      setRender(!render);
    }
  };
  const handleReviewText = (e) => {
    setReviewText(e);
  };
  if (reviewsLoader && reviews?.totalItems !== 0) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin
          indicator={<LoadingOutlined />}
          className="flex justify-center"
          size="large"
        />
      </div>
    );
  }
  return (
    <div
      className={`${
        isOpen || openReplyIndex !== null ? "xl:w-90%" : "xl:w-90%"
      }`}
    >
      <div className="flex pt-3 pl-3">
        <Link to="/main/profile">
          <div className="flex items-center">
            <img src={Back} alt="Edit Icon" className="mr-1" />
            <span className="text-lg font-bold text-black ml-1">Reviews</span>
          </div>
        </Link>
      </div>
      {reviews?.items?.map((item, i) => (
        <div key={i}>
          <ReviewsOrderDetails
            orderno={item?.orderId?._id.substr(-6)}
            sname={item?.serviceDetails?.serviceName}
            datetime={moment
              .utc(item?.orderId?.createdAt)
              .format("MM/DD/YYYY h:mm A")}
            business={item?.businessId?.businessName}
            businessImg={item?.businessId?.profileImage}
            type={"Business"}
          />
          <ReviewsCustomer
            customer={`${item?.customerUserId?.firstName} ${item?.customerUserId?.lastName}`}
            customerImg={item?.customerUserId?.profileImage}
            review={item}
            id={item?._id}
            reviewsLength={item?.comments?.length}
            date={moment(item?.createdAt).format("MM/DD/YYYY")}
            rating={item?.rating}
            msg={""}
            onReplyButtonClick={toggleReplySection}
          />
          {openReplyIndex === item?._id && item?.comments?.length == 1 && (
            <Card className="mx-2.5 bg-primaryPurple rounded-t-none text-white">
              <div className="sm:grid sm:grid-cols-5 grid grid-cols-2 mx-2 my-1.5 justify-between">
                <div className="flex items-center">
                  <img src={item.customerImg} alt="" />
                  <span className="ml-1">You</span>
                </div>

                <div className="col-span-3">
                  <TextArea
                    className="!h-6 col-span-2 "
                    placeholder="Enter your review here....."
                    handleTextChange={handleReviewText}
                  />
                </div>
                <div className="flex justify-end">
                  <Button
                    title={"Reply"}
                    className="w-10 mt-1 !h-4 "
                    color={colors.primaryPurple}
                    onClick={onReplyButtonClick}
                  />
                </div>
                <div></div>
              </div>
            </Card>
          )}
          {item?.comments?.length > 1 && (
            <Card className="mx-2.5 bg-primaryPurple rounded-t-none text-white">
              <div className="sm:grid sm:grid-cols-5 grid grid-cols-2 mx-2 my-1.5 justify-between">
                <div className="flex items-center">
                  <span className="ml-1">You</span>
                </div>
                <div className="col-span-4">
                  {item?.comments[1]?.commentText}
                </div>
              </div>
            </Card>
          )}
        </div>
      ))}
      <div className="flex justify-center items-center pagination-container my-2">
        <Pagination
          current={currentPage}
          total={reviews?.totalItems}
          pageSize={pageSize}
          onShowSizeChange={handleSizeChange}
          pageSizeOptions={[3, 10, 20, 30]}
          onChange={(e) => {
            handlePageChange(e);
          }}
        />
      </div>

      {isOpen && <DeleteMemberModal onCancel={hideModal} onOk={hideModal} />}
    </div>
  );
};
export default Reviews;
